/**
 * Created by rkotha on 8/17/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('HomeMainController', HomeMainController);

    HomeMainController.$inject = ['$scope', 'Principal', 'LoginService', '$state','$rootScope','$window'];

    function HomeMainController($scope, Principal, LoginService, $state,$rootScope,$window) {
        var vm = this;
        vm.isAdmin;
        var adminAuthorities = ['Administrators'];
        Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result){
            vm.isAdmin  = result;
            if(vm.isAdmin === true){
                $scope.go('home-main.important-announcements');
            }
            else{
                $scope.go('user-home-Page');
            }
        });
        $scope.tabData   = [
            {
                heading: 'HomePage',
                route:   'home-main.home-page',
                class: 'btn-lg'
            },
            {
                heading: 'Aurora Networks Account Contacts',
                route:   'home-main.arris-account-contacts',
                class: 'btn-lg'
            },
            {
                heading: 'Important Announcements',
                route:   'home-main.important-announcements',
                class: 'btn-lg'
            }

        ];

        $scope.go = function(route){
            $state.go(route);
        };


       // $scope.go('temp-main.home-page');

    }
})();
